import { defineStore } from 'pinia'

import router from '@/router/index'
import axios from '@/api/index'
import qs from 'qs'
import Nprogress from 'nprogress';
import  '../../node_modules/js-loading-overlay/dist/js-loading-overlay.min.js'
export const useaccountsettingStore = defineStore('accountsettingstore', {
    state: () => {
        return {
            add_location: [],
            myZoneDetailsList: [],
            myZonePermissionsList: [],
            account_setting_list: []
        }
    },
    getters: {
        add_locationState: (state) => state.add_location,
        addLocationGetterstate() {
            return this.add_locationState
        },
        myZoneDetailsListState: (state) => state.myZoneDetailsList,
        myZoneDetailsGetters() {
            return this.myZoneDetailsListState
        },
        myZonePermissionsListState: (state) => state.myZonePermissionsList,
        myZoneDetailsPermissionGetters() {
            return this.myZonePermissionsListState
        },
        account_setting_listState: (state) => state.account_setting_list,
        accountSettingGetter() {
            return this.account_setting_listState
        },
    },
    actions: {
        clearAccountSettingState() {
            this.account_setting_list = [];
            this.add_location = [];            
        },
        inventoryUsersLocation(postData) {
            return new Promise((resolve, reject) => {
                JsLoadingOverlay.show({
                    'spinnerIcon': 'ball-clip-rotate',
                    "overlayOpacity": "0.6",
                    "spinnerSize": "2x",
                    "lockScroll": true,
                });
                axios.post('/inventory/get_account_users_and_locations', qs.stringify(postData, {
                    parseArrays: false
                }))
                    .then(response => {
                        JsLoadingOverlay.hide();
                        if (response.data.status != 'success') {
                            reject(response.data.message);
                            return;
                        }
                        resolve(response.data);    
                    })
                    .catch(error => console.log(error));
            });
        },
        submitTransferItem(postData) {
            return new Promise((resolve, reject) => {
                JsLoadingOverlay.show({
                    'spinnerIcon': 'ball-clip-rotate',
                    "overlayOpacity": "0.6",
                    "spinnerSize": "2x",
                    "lockScroll": true,
                });
                axios.post('/inventory/transfer_item', postData, {
                    headers: { 'Content-Type': 'multipart/form-data' }
                })
                    .then(response => {
                        JsLoadingOverlay.hide();
                        if (response.data.status != 'success') {
                            reject(response.data.message);
                            return;
                        }
                        resolve(response.data);
                    })
                    .catch(error => console.log(error));
            });
        },
        addLocationForm(postData) {
            return new Promise((resolve, reject) => {
                JsLoadingOverlay.show({
                    'spinnerIcon': 'ball-clip-rotate',
                    "overlayOpacity": "0.6",
                    "spinnerSize": "2x",
                    "lockScroll": true,
                });
                axios.post('/inventory/manage_locations', qs.stringify(postData, {
                    parseArrays: false
                }))
                    .then(response => {
                        JsLoadingOverlay.hide();
                        if (response.data.status != 'success') {
                            reject(response.data.message);
                            return;
                        }
                        this.addLocation(response.data.data);                        
                        resolve(response.data);    
                    })
                    .catch(error => console.log(error));
            });
        },
        addLocation(data) {
            this.add_location = data;
        },
        fetchMyZoneDetailsList(authData) {
            Nprogress.start()
            return new Promise((resolve, reject) => {
                axios.get('/account_settings/get_all_my_zone_detail/' + authData.accountId + "/" + authData.level + "/" + true + '/' + authData.limit + '/' + authData.page + '/' + authData.search + '/' + authData.sorting)
                    .then(res => {
                        Nprogress.done()
                        var tData = {};
                        var parseData = JSON.parse(res.data.message);
                        this.myZonePermissionsList = res.data.permissions;
                        this.myZoneDetailsList = [];
                
                        if (parseData != null) {
                            tData[res.data.accountId + '-myZoneDetailsList'] = parseData;
                            this.myZoneDetailsList = tData;
                        }                      
                        resolve(res.data);
                    })
                    .catch(error => console.log(error))
            });
        },
        uploadProfilePicture(postData) {
            return new Promise((resolve, reject) => {
                JsLoadingOverlay.show({
                    'spinnerIcon': 'ball-clip-rotate',
                    "overlayOpacity": "0.6",
                    "spinnerSize": "2x",
                    "lockScroll": true,
                });
                axios
                    .post("AccountSettings/upload_profile_image_vue", postData, {
                        headers: {
                            "Content-Type": "multipart/form-data",
                        },
                    })
                    .then(response => {
                        JsLoadingOverlay.hide();
                        if (response.data.status != 'success') {
                            reject(response.data.message);
                            return;
                        }
                        resolve(response.data);    
                    })
                    .catch(error => console.log(error));
            });
        },
        fetchAccountSettingData(authData) {
            Nprogress.start();
            if (authData.adminId == undefined || authData.accountId == undefined) {
                axios.get('/account_settings/account_setting_list')
                    .then(res => {
                        Nprogress.done()
                        this.account_setting_list = res.data.message
                    })
                    .catch(error => console.log(error))
            } else {
                axios.get('/account_settings/account_setting_list/' + authData.adminId + '/' + authData.accountId+ '/' + authData.limit+ '/' + authData.page+ '/' + authData.sorting)
                    .then(res => {
                        Nprogress.done()
                        this.account_setting_list = res.data.message
                    })
                    .catch(error => console.log(error))
            }
    
        },
        allowableAccounts(postData) {
            return new Promise((resolve, reject) => {
                JsLoadingOverlay.show({
                    'spinnerIcon': 'ball-clip-rotate',
                    "overlayOpacity": "0.6",
                    "spinnerSize": "2x",
                    "lockScroll": true,
                });
                axios.post('/AccountSettings/save_allowable_accounts', qs.stringify(postData, {
                    parseArrays: false
                }))
                    .then(response => {
                        JsLoadingOverlay.hide();
                        if (response.data.status != 'success') {
                            reject(response.data.message);
                            return;
                        }
                        this.add_location = response.data.data;
                        resolve(response.data);
    
                    })
                    .catch(error => console.log(error));
            });
        },
        allowableLocationsAdmin(postData) {
            return new Promise((resolve, reject) => {
                JsLoadingOverlay.show({
                    'spinnerIcon': 'ball-clip-rotate',
                    "overlayOpacity": "0.6",
                    "spinnerSize": "2x",
                    "lockScroll": true,
                });
                axios.post('/AccountSettings/save_allowable_locations', qs.stringify(postData, {
                    parseArrays: false
                }))
                    .then(response => {
                        JsLoadingOverlay.hide();
                        if (response.data.status != 'success') {
                            reject(response.data.message);
                            return;
                        }
                        //this.add_location = response.data.data;
                        resolve(response.data);
    
                    })
                    .catch(error => console.log(error));
            });
        },
        sendAccountSettingData(postData) {
            return new Promise((resolve, reject) => {
                JsLoadingOverlay.show({
                    'spinnerIcon': 'ball-clip-rotate',
                    "overlayOpacity": "0.6",
                    "spinnerSize": "2x",
                    "lockScroll": true,
                });
                axios.post('/AccountSettings/edit_admin.json', qs.stringify(postData, {
                    parseArrays: false
                }))
                    .then(response => {
                        JsLoadingOverlay.hide();
                        if (response.data.status != 'success') {
                            reject(response.data.message);
                            return;
                        }
                        resolve(response.data);
                    })
                    .catch(error => console.log(error));
            });
        },
        deleteProfile(postData) {
            return new Promise((resolve, reject) => {
                JsLoadingOverlay.show({
                    'spinnerIcon': 'ball-clip-rotate',
                    "overlayOpacity": "0.6",
                    "spinnerSize": "2x",
                    "lockScroll": true,
                });
                axios.post('/AccountSettings/delete_admin_profile_image', qs.stringify(postData, {
                    parseArrays: false
                }))
                    .then(response => {
                        JsLoadingOverlay.hide();
                        if (response.data.status != 'success') {
                            reject(response.data.message);
                            return;
                        }
                        resolve(response.data);    
                    })
                    .catch(error => console.log(error));
            });
        },
        inventoryQuantity(postData) {
            return new Promise((resolve, reject) => {
                JsLoadingOverlay.show({
                    'spinnerIcon': 'ball-clip-rotate',
                    "overlayOpacity": "0.6",
                    "spinnerSize": "2x",
                    "lockScroll": true,
                });
                axios.post('/inventory/get_quantity_type', qs.stringify(postData, {
                    parseArrays: false,
                }))
                    .then(response => {
                        JsLoadingOverlay.hide();
                        if (response.data.status != 'success') {
                            reject(response.data.message);
                            return;
                        }
                        resolve(response.data);    
                    })
                    .catch(error => console.log(error));
            });
        },
        deleteSelectedSessions(postData) {
            return new Promise((resolve, reject) => {        
                JsLoadingOverlay.show({
                    'spinnerIcon': 'ball-clip-rotate',
                    "overlayOpacity": "0.6",
                    "spinnerSize": "2x",
                    "lockScroll": true,
                });
                axios.post('/account_settings/delete_redis_session/', qs.stringify(postData, {
                parseArrays: false
                }))
                .then(response => {
                    
                    JsLoadingOverlay.hide();
                    if (response.data.message != 'success') {
                    reject(response.data.message);
                    return;
                    }
                
                    resolve(response.data);
                })
                .catch(error => console.log(error))
            });
        },
        deleteAllSessions(postData) {
            return new Promise((resolve, reject) => {        
                JsLoadingOverlay.show({
                    'spinnerIcon': 'ball-clip-rotate',
                    "overlayOpacity": "0.6",
                    "spinnerSize": "2x",
                    "lockScroll": true,
                });
              axios.post('/account_settings/delete_all_redis_session/', qs.stringify(postData, {
                parseArrays: false
              }))
                .then(response => {
                  JsLoadingOverlay.hide();
                  if (response.data.message != 'success') {
                    reject(response.data.message);
                    return;
                  }
                  resolve(response.data);
                })
                .catch(error => console.log(error))
            });
        },
        allowIPAddress(postData) {
            return new Promise((resolve, reject) => {
                JsLoadingOverlay.show({
                    'spinnerIcon': 'ball-clip-rotate',
                    "overlayOpacity": "0.6",
                    "spinnerSize": "2x",
                    "lockScroll": true,
                });
                axios.post('/AccountSettings/add_admin_ip', qs.stringify(postData, {
                    parseArrays: false
                }))
                    .then(response => {
                        JsLoadingOverlay.hide();
                        if (response.data.status != 'success') {
                            reject(response.data.message);
                            return;
                        }
                        this.account_setting_list.adminIps.push(response.data.newIp);
                        resolve(response.data);
                    })
                    .catch(error => console.log(error));
            });
        },
        deleteAdminIPAddress(postData) {
            return new Promise((resolve, reject) => {
                JsLoadingOverlay.show({
                    'spinnerIcon': 'ball-clip-rotate',
                    "overlayOpacity": "0.6",
                    "spinnerSize": "2x",
                    "lockScroll": true,
                });
                axios.post('/AccountSettings/del_admin_ip', qs.stringify(postData, {
                    parseArrays: false
                }))
                    .then(response => {
                        JsLoadingOverlay.hide();
                        if (response.data.status != 'success') {
                            reject(response.data.message);
                            return;
                        }
                        var index = this.account_setting_list.adminIps.findIndex(Element => Element.AdminIp.id == postData.adminIpId);
                        this.account_setting_list.adminIps.splice(index, 1);                        
                        resolve(response.data);    
                    })
                    .catch(error => console.log(error));
            });
        },
        changePassword(postData) {
            return new Promise((resolve, reject) => {
                JsLoadingOverlay.show({
                    'spinnerIcon': 'ball-clip-rotate',
                    "overlayOpacity": "0.6",
                    "spinnerSize": "2x",
                    "lockScroll": true,
                });
                axios.post('/account_settings', qs.stringify(postData, {
                    parseArrays: false
                }))
                    .then(response => {
                        JsLoadingOverlay.hide();
                        if (response.data.status != 'success') {
                            reject(response.data.message);
                            return;
                        }
                        resolve(response.data);    
                    })
                    .catch(error => console.log(error));
            });
        },
        getUsersLocation(postData) {
            return new Promise((resolve, reject) => {
                JsLoadingOverlay.show({
                    'spinnerIcon': 'ball-clip-rotate',
                    "overlayOpacity": "0.6",
                    "spinnerSize": "2x",
                    "lockScroll": true,
                });
                axios.post('/users/get_account_users_and_locations', qs.stringify(postData, {
                    parseArrays: false
                }))
                    .then(response => {
                        JsLoadingOverlay.hide();
                        if (response.data.status != 'success') {
                            reject(response.data.message);
                            return;
                        }
                        resolve(response.data);
    
                    })
                    .catch(error => console.log(error));
            });
        },        
    }
});